<template>
  <div>
    <div>
      <h1>{{ $t("title.valorisActivityReportTitle") }}</h1>
      <div class="container-alb valoris-activity-report">
        <b-container fluid class="border-box">
          <b-row class="valoris-activity-report__content border-box">
            <b-col xl="6" md="6" class="valoris-activity-report__left border-box">
              <p class="valoris-activity-report__description">{{ $t("title.valorisActivityReportDescription") }}</p>
              <button type="button" class="notification-action custom-notification-action valoris-activity-report__button"
                      :disabled="valorisActivityDownloading" @click="downloadValorisActivityReport()">
                <font-awesome-icon icon="download" />
                {{ valorisActivityDownloading ? $t("title.loadingPopupMessage") : $t("title.valorisActivityReportDownload") }}
              </button>
            </b-col>
            <b-col xl="6" md="6" class="valoris-activity-report__right border-box">
              <span>{{ $t("title.valorisActivityReportPeriod") }}:</span>
              <date-range class="valoris-activity-report__period" :time="valorisActivityPeriod"
                          @close="valorisActivityPeriodChanged" />
            </b-col>
          </b-row>
          <b-row v-if="valorisActivityError" class="mt-3">
            <b-col><p class="valoris-activity-report__error mb-0">{{ $t("title.valorisActivityReportError") }}</p></b-col>
          </b-row>
        </b-container>
      </div>

      <h1>{{ $t("title.searchPageName") }}</h1>
      <div class="container-alb company-search-section">
        <b-container fluid class="border-box">
          <form @submit.prevent="">
            <b-row class="border-box">
              <b-col xl="4" md="4" class="border-box mb-4">
                <span>{{ $t("title.searchByCompanyType") }}:</span>
                <select class="w-100" @change="companyTypeSelected">
                  <option :selected="this.companyType === 'customer'" value="customer">{{ $t("title.searchCompanyTypeClient") }}</option>
                  <option :selected="this.companyType === 'affiliate'" value="affiliate">{{ $t("title.searchCompanyTypeAffiliate") }}</option>
                </select>
              </b-col>
            </b-row>
            <b-row class="border-box">
              <b-col xl="4" md="4" class="border-box mb-4">
                <span>{{ $t("title.searchByCodall") }}:</span>
                <input type="text" class="formedituser" v-model="codall" v-on:keyup.enter="searchCompany()"
                       @keyup="updateInputCharacters()" />
              </b-col>
              <b-col xl="4" md="4" class="border-box mb-4">
                <span>{{ $t("title.searchByProduct") }}:</span>
                <select class="w-100" @change="productSelected">
                  <option selected disabled>{{ $t("title.cardStatus_") }}</option>
                  <option v-for="(entry, index) in this.allProducts" :key="index" :value="+ entry.card"
                          :selected="isSelectedProduct(entry.brand)">{{ entry.name }}</option>
                </select>
              </b-col>
            </b-row>
            <b-row class="border-box">
              <b-col xl="4" md="4" class="border-box mb-4">
                <span>{{ $t("title.searchByCompanyName") }}:</span>
                <input type="text" class="formedituser" v-model="clientName" v-on:keyup.enter="searchCompany()"
                       @keyup="updateInputCharacters()" />
              </b-col>
              <b-col xl="4" md="4" class="border-box mb-4">
                <span>{{ $t("title.searchByFiscalCode") }}:</span>
                <input type="text" class="formedituser" autocomplete="anyrandomstring" name="fiscalCode" value=" "
                       v-model="fiscalCode" v-on:keyup.enter="searchCompany()" @keyup="updateInputCharacters()" />
              </b-col>
              <b-col xl="4" md="4" class="border-box"></b-col>
            </b-row>
            <b-row class="border-box">
              <b-col xl="4" md="4" class="border-box mb-4 mx-auto text-center">
                <a class="notification-action custom-notification-action" @click="searchCompany()">{{
                    $t("title.searchButtonLabel") }}</a>
              </b-col>
            </b-row>
          </form>
        </b-container>
      </div>
      <div v-if="this.companies" class="container-alb">
        <table cellpadding="10" cellspacing="0" width="95%" class="hover-table" align="center">
          <thead>
            <tr>
              <td valign="middle">
                <strong>{{ $t("title.companyCodeLabel") }}</strong>&nbsp;
              </td>
              <td valign="middle">
                <strong>{{ $t("title.searchByCompanyName") }}</strong>&nbsp;
              </td>
              <td class="priority-1" valign="middle">
                <strong>{{ $t("title.fiscalCodeLabel") }}</strong>&nbsp;
              </td>
              <td valign="middle">
                <strong>{{ $t("title.beneficiariesTableAction") }}</strong>&nbsp;
              </td>
            </tr>
          </thead>
          <tbody>
            <tr valign="middle" class="trhover" v-if="companies.length === 0">
              <td colspan="12">{{ $t("title.searchNoCompanies") }}</td>
            </tr>
            <template v-for="(company, index) in companies" :key="index">
              <tr :id="index" class="trhover parent" :class="index % 2 === 0 && 'gri-cell'">
                <td valign="middle">
                  <a class="detailsOrderMobile priority-show-5 display-inline-block" @click="selectCompany(index)">
                    <font-awesome-icon icon="minus-circle" v-if="detailsMobile && company === companySelected" />
                    <font-awesome-icon icon="plus-circle" v-else />&nbsp;&nbsp;
                  </a>
                  <strong>{{ company.company_id }}</strong>
                </td>
                <td valign="middle" class="priority-0">{{ company.name }}</td>
                <td valign="middle" class="priority-1">
                  {{ company.fiscal_code }}
                </td>
                <td valign="middle">
                  <a class="see-more" @click="resetAccount(company)">
                    <strong>{{ $t("title.resetCompany") }}</strong>&nbsp;
                    <!-- <font-awesome-icon icon="arrow-alt-circle-right" size="2x" /> -->
                  </a>
                </td>
                <td valign="middle">
                  <a class="see-more" :href="'/' + companyType + '/dashboard'" @click="setCompanyId(company.company_id)">
                    <strong>{{ $t("title.selectCompany") }}</strong>&nbsp;

                    <!-- <font-awesome-icon icon="arrow-alt-circle-right" size="2x" /> -->
                  </a>
                </td>
                <td colspan="4" valign="middle"></td>
              </tr>
              <tr :id="index + companies.length" class="child" :class="index % 2 === 0 && 'gri-cell'"
                v-show="detailsMobile && company === companySelected">
                <td colspan="12">
                  <p class="priority-show-0">
                    <strong>{{ $t("title.searchByCompanyName") }} : &nbsp;&nbsp;</strong>
                    <span>{{ company.name }}</span>
                  </p>
                  <p class="priority-show-1">
                    <strong>{{ $t("title.fiscalCodeLabel") }} : &nbsp;&nbsp;</strong>
                    <span>{{ company.fiscal_code }}</span>
                  </p>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
      <div v-if="this.searchError" class="container-alb">
        <table cellpadding="10" cellspacing="0" width="95%" class="hover-table" align="center">
          <thead>
            <tr>
              <td valign="middle">
                <strong>{{ $t("title.errorMessage" + this.searchError) }}</strong>&nbsp;
              </td>
            </tr>
          </thead>
        </table>
      </div>
    </div>
    <div id="modal_popup_loading" class="modal-popup">
      <div class="modal-popup-content">
        <img src="@/assets/images/loading.gif" />
        <p v-html="$t('title.loadingPopupMessage')"></p>
      </div>
    </div>
    <div id="modal_popup_loading" class="modal-popup">
      <div class="modal-popup-content">
        <img src="@/assets/images/loading.gif" />
        <p v-html="$t('title.loadingPopupMessage')"></p>
      </div>
    </div>
  </div>
</template>

<script>
import httpServiceCustomer from "@/http/http-customer.js";
import httpServiceBenef from "@/http/http-ben-support.js";
import Cookies from "js-cookie";
import { BContainer, BRow, BCol } from "bootstrap-vue-3";
import products from "@/assets/json/products.js";
import DateRange from "@/components/DateRange.vue";
import moment from "moment";
import { saveAs } from "file-saver";

export default {
  props: {
    customer: Object,
    msg: String
  },
  components: {
    "b-container": BContainer,
    "b-row": BRow,
    "b-col": BCol,
    DateRange
  },
  data() {
    return {
      companies: null,
      detailsMobile: false,
      companySelected: null,
      selectedCompanyId: null,
      companyType: "customer",
      codall: null,
      clientCode: null,
      clientName: null,
      fiscalCode: null,
      product: null,
      perPage: 10,
      currentPage: 1,
      sortDirection: "desc",
      searchError: null,
      valorisActivityPeriod: [moment().subtract(1, "month"), moment()],
      valorisActivityDownloading: false,
      valorisActivityError: false
    };
  },
  methods: {
    companyTypeSelected(event) {
      this.companyType = event.target.value;
    },
    productSelected(event) {
      this.product = event.target.value;
    },
    valorisActivityPeriodChanged(period) {
      this.valorisActivityPeriod = period;
      this.valorisActivityError = false;
    },
    downloadValorisActivityReport() {
      if (!this.valorisActivityPeriod || this.valorisActivityPeriod.length !== 2) return;

      this.valorisActivityDownloading = true;
      this.valorisActivityError = false;
      const reportParams = "?start_date=" + moment(this.valorisActivityPeriod[0]).format("YYYY-MM-DD") +
        "&end_date=" + moment(this.valorisActivityPeriod[1]).format("YYYY-MM-DD");

      httpServiceBenef.beneficiariesService
        .getValorisActivityReport(reportParams, Cookies.get("token"))
        .then((response) => {
          if (response.status !== 200 || !response.data) {
            throw new Error("Unable to download Valoris activity report");
          }

          const contentDisposition = response.headers["content-disposition"] || "";
          const filenameMatch = contentDisposition.match(/filename\*?=(?:UTF-8''|\")?([^;\"]+)/i);
          const filename = filenameMatch
            ? decodeURIComponent(filenameMatch[1].trim())
            : "raport_activitate_valoris.xls";
          const blob = new Blob([response.data], {
            type: response.headers["content-type"] || "application/vnd.ms-excel"
          });

          saveAs(blob, filename);
        })
        .catch(() => { this.valorisActivityError = true; })
        .finally(() => { this.valorisActivityDownloading = false; });
    },
    selectCompany(index) {
      this.companySelected = this.companies[index];
      this.detailsMobile = !this.detailsMobile;
    },
    isSelectedProduct(product) {
      return product === this.product;
    },
    searchCompany() {
      if (this.codall || this.clientName || this.fiscalCode) {
        this.showModalPopup("modal_popup_loading", true);
        this.companies = [];


        var formData =
          "?per_page=" + this.perPage + "&page=" + this.currentPage;
        if (this.codall) {
          formData += "&company_id=" + this.codall;
        }
        if (this.clientName) {
          formData += "&name=" + this.clientName;
        }
          formData += "&type=" + this.companyType;
        if (this.fiscalCode) {
          formData += "&fiscal_code=" + this.fiscalCode;
        }
        if (this.product) {
          formData += "&product=" + this.product;
        }
        localStorage.removeItem("customer_data");
        httpServiceCustomer.customerService
          .searchCompany(formData, Cookies.get("token"))
          .then(function (response) {
            return response;
          })
          .catch(error => {
            this.searchError = error.response.status;
            return error.response;
          })
          .then(response => {
            if (response.status == 200) {
              this.companies = response.data;
            } else if (response.status == 400 || response.status == 403) {
              this.companies = null;
              this.searchError = response.status;
            }
            this.showModalPopup("modal_popup_loading", false);
          });
      }
    },
    resetAccount(company) {
        this.showModalPopup("modal_popup_loading", true);

        let formData = {
          code: company.company_id,
          from_source_id: this.companyType == "customer" ? "CST" : "AFF",
          first_name: company.name,
          last_name: company.name,
          password: company.fiscal_code,
          active: true,
        };

        httpServiceCustomer.customerService
          .resetCompanyAccount(formData, Cookies.get("token"))
          .then(function (response) {
            return response;
          })
          .catch(error => {
            return error.response;
          })
          .then(response => {
            if (response.status == 200) {
              console.log(response);
            } else if (response.status == 400 || response.status == 403) {
            }
            this.showModalPopup("modal_popup_loading", false);
          });
    },
    setCompanyId(id) {
      sessionStorage.setItem('selectedCompany', JSON.stringify({
          company_id: id,
          // role: this.customer.role
          role: this.companyType == "customer" ? "CST" : "AFF",
          userRole: "FAC"
                  }));
      localStorage.removeItem("customer_data");
    },
    showModalPopup(elementId, show) {
      if (show) {
        document.getElementById(elementId).style.visibility = "visible";
      } else {
        document.getElementById(elementId).style.visibility = "hidden";
      }
    },
    onlyAlphaNumericCharacters(variable) {
      if (/^[a-zA-Z0-9]*$/i.test(variable)) {
        return variable;
      } else {
        return variable.replace(/[&\/\\|`#@\[\]\-,+=()$~%.'":*!?<>{}]/g, "");
      }
    },
    updateInputCharacters() {
      this.codall = this.onlyAlphaNumericCharacters(this.codall);
      this.fiscalCode = this.onlyAlphaNumericCharacters(this.fiscalCode);
      this.$forceUpdate();
    }
  },
  computed: {
    allProducts() {
      return products;
    }
  },
  mounted() {
    sessionStorage.setItem('selectedCompany', JSON.stringify({
          company_id: 0,
          // role: this.customer.role
          role: this.customer.role
                  }));
    localStorage.removeItem("customer_data");
    localStorage.removeItem("affiliate_data");
  }
};
</script>
<style scoped src="@/assets/styles/beneficiary.css"></style>
<style scoped>
.valoris-activity-report { margin-bottom: 25px; }

.valoris-activity-report__content {
  align-items: flex-start;
}

.valoris-activity-report__left {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.valoris-activity-report__right {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.valoris-activity-report__description {
  margin: 0 0 15px;
}

.valoris-activity-report__period {
  margin-top: 5px;
}

.valoris-activity-report__button {
  border: 0;
  white-space: nowrap;
}

.valoris-activity-report__button:disabled {
  cursor: wait;
  opacity: 0.65;
}

.valoris-activity-report__error {
  color: #d71920;
}

@media (max-width: 767px) {
  .valoris-activity-report__content {
    display: flex;
    flex-direction: column;
  }

  .valoris-activity-report__left,
  .valoris-activity-report__right {
    width: 100%;
    align-items: flex-start;
  }

  .valoris-activity-report__left {
    display: contents;
  }

  .valoris-activity-report__description {
    order: 1;
    margin-bottom: 15px;
    padding-left: 12px;
    padding-right: 12px;
    box-sizing: border-box;
  }

  .valoris-activity-report__right {
    order: 2;
    margin-bottom: 15px;
  }

  .valoris-activity-report__button {
    order: 3;
    margin-left: 12px;
  }
}
</style>
